import React, { useState, useEffect } from "react";
import "../../assets/styles/patients.scss";
import DataGrid from '../../components/common/dataGrid/dataGrid';
import {
  generateColumnMetadata,
  orderObj,
  mask,
  Feature,
} from "../../utils/utils";
import {
  commonPostApi,
} from "../../utils/apiService";
import {
  nonRequirePatientListField,
  TenantReportColumns,
} from "../../utils/serviceData";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { SORT_ORDER } from "../../constants/sortOrder";

const Tenant = ({api, dateRange}) => {
  const navigate = useNavigate();
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const id = useSelector(state=> state.common.camp?.camp_details_id);
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "patient_name",
    sortDir: SORT_ORDER.ASC,
  });

  const init = async (navigator) => {
    let currentObj = {
        page: navigator?.page,
        limit: navigator?.rows,
        sortFields: [[navigator?.sortBy, navigator?.sortDir]],
        ...dateRange
    };

    await commonPostApi(api, currentObj)
      .then((data = []) => {
        if (data?.data?.data) {
          console.log(data)
          const finalData = data?.data?.data;
          const updatedPatient = finalData.map((p) => ({
            ...p, // Keep other properties unchanged
            aadhar_no: mask(p.aadhar_no),
          }));
          setNavigator((prev) => ({
            ...prev,
            totalRecords: data?.data?.total,
            page: data?.data?.currentPage,
          }));
          setColumns(
            orderObj(
              [
                "patient_name",
                "patient_code",
                "surgery_type",
                "total_amount",
                "paid_amount",
                "balance_due",
              ],
              generateColumnMetadata({
                data: finalData,
                nonRequireField: nonRequirePatientListField,
                alias: {
                  patient_name: "patient",
                  patient_code: "patient_id",
                  type: "surgery_type",
                  total_amount: "total_amount",
                  paid_amount: "paid_amount",
                  balance_due: "balance_due",
                },
                defaultColumnsArr:TenantReportColumns,
              }), 
            )
          );
          setValues(updatedPatient);
          setLoading(false);
        } else {
          setNavigator((prev) => ({
            ...prev,
            totalRecords: 1,
            page: 1,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    init(navigator);
  }, [id]);

  useEffect(() => {
    init(navigator);
  }, [dateRange]);

  function onPageChange(event) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      first: event?.first,
      page: event.page + 1,
    }));
    init({
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    });
  }

  const onRowCountChange = (e) => {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      page: 1,
      first: 0,
      rows: e?.target?.value,
    });
  };

  const onSortClick = (event) => {
    setLoading(true);
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    setNavigator((prev) => ({
      ...prev,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    }));
    init({
        ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    });
  };

  const onRowClick = (event) => {
    if(Feature?.featureVerify(Feature.listOfFeature.patientVisitView)){
      navigate(`/reports/tenant/patient/${event?.data?.patient_id}`);
    }
  };

  return (
    <div className="Patients__main-container" style={{background: "#fff"}}>
      <DataGrid
        onSortClick={onSortClick}
        onRowCountChange={onRowCountChange}
        onRowClick={onRowClick}
        onPageChange={onPageChange}
        sortable={true}
        navigator={navigator}
        column={columns}
        value={values}
        loading={loading}
        isAccordionEnabled={false}
        isPaginatorEnabled={true}
      />
    </div>
  );
};

export default Tenant;
